export default __webpack_public_path__ + "static/media/L0006.d32942cf.png";